import { render, staticRenderFns } from "./OccupationFact.vue?vue&type=template&id=ad56f8f2&scoped=true&"
import script from "./OccupationFact.vue?vue&type=script&lang=js&"
export * from "./OccupationFact.vue?vue&type=script&lang=js&"
import style0 from "./OccupationFact.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OccupationFact.vue?vue&type=style&index=1&id=ad56f8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad56f8f2",
  null
  
)

export default component.exports